import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import StatusLayout from "./StatusLayout";
import { useCase } from "../../context/CaseContext";
import { scanAndUploadDocuments } from "../../lib/everifyStatusApi";

const ScanAndUploadPage = () => {
  const { activeCaseNumber } = useCase();
  const navigate = useNavigate();
  const [frontFile, setFrontFile] = useState(null);
  const [backFile, setBackFile] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!activeCaseNumber) {
      toast.error("No active case found.");
      return;
    }
    if (!frontFile || !backFile) {
      toast.error("Please upload both front and back images.");
      return;
    }
    try {
      setIsSubmitting(true);
      await scanAndUploadDocuments(activeCaseNumber, frontFile, backFile);
      toast.success("Documents uploaded successfully.");
      navigate("/");
    } catch (error) {
      toast.error("Unable to upload documents.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <StatusLayout
      title="Document Upload Required"
      description="Please upload a copy of the employee’s document for verification."
    >
      <form className="status-section status-form" onSubmit={handleSubmit}>
        {/* <label>
          Front of Document <span className="required-asterisk">*</span>
          <input
            type="file"
            accept="image/*,.pdf"
            onChange={(event) => setFrontFile(event.target.files?.[0] || null)}
            required
          />
        </label> */}
        <label>
          <span className="field-label">
            Front of Document <span className="required-asterisk">*</span>
          </span>
          <input
            type="file"
            accept="image/*,.pdf"
            onChange={(event) => setFrontFile(event.target.files?.[0] || null)}
            required
          />
        </label>

        {/* <label>
          Back of Document <span className="required-asterisk">*</span>
          <input
            type="file"
            accept="image/*,.pdf"
            onChange={(event) => setBackFile(event.target.files?.[0] || null)}
            required
          />
        </label> */}
        <label>
          <span className="field-label">
            Back of Document <span className="required-asterisk">*</span>
          </span>
          <input
            type="file"
            accept="image/*,.pdf"
            onChange={(event) => setBackFile(event.target.files?.[0] || null)}
            required
          />
        </label>

        <div className="status-actions">
          <button type="submit" className="status-primary" disabled={isSubmitting}>
            {isSubmitting ? "Uploading..." : "Submit"}
          </button>
          {/* <button type="button" className="status-muted-button" onClick={() => navigate("/")}>
            Cancel
          </button> */}
        </div>
      </form>
    </StatusLayout>
  );
};

export default ScanAndUploadPage;
